import { Button, Modal } from 'antd';
import React from 'react';

const DeleteProjectAgency = ({
  showModal = false,
  setShowModal,
  title,
  name,
  deleteProjectAgency,
  mutationId,
  setMutationId,
}) => {
  const handleOk = () => {
    deleteProjectAgency({
      variables: {
        id: mutationId,
      },
    });

    setShowModal(false);
  };

  const handleCancel = () => {
    setMutationId('');
    setShowModal(false);
  };
  return (
    <div>
      <Modal
        maskClosable={false}
        centered
        closable={false}
        footer={null}
        open={showModal}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <h2>{`Remove ${title}`}</h2>
        <p>Are you sure you want to remove {name}?</p>
        <div className="form-buttons">
          <Button
            id="delete-cancel-button"
            shape="round"
            className="cancel-button"
            onClick={handleCancel}
          >
            No, Cancel
          </Button>
          <Button
            id="delete-confirm-button"
            shape="round"
            type="primary"
            className="save-button"
            onClick={handleOk}
          >
            Yes, Remove
          </Button>
        </div>
      </Modal>
    </div>
  );
};
export default DeleteProjectAgency;
